import { ApiCall } from "components/common/services/ApiServices";
import type { ListenerDataProps } from "../annotations/WhatsAppAnnotations";
import { AJ_WEB_CONNECTOR } from "Constants";
import { UPDATE_WHATSAPP_MESSAGE } from "../../../../routes/ApiEndpoints";

/**
 * Fetch messages based on personID.
 */
export const UpdateMessage = async (whatsAppData: ListenerDataProps) => {
  const response = await ApiCall.service(
    UPDATE_WHATSAPP_MESSAGE,
    "POST",
    whatsAppData,
    false,
    AJ_WEB_CONNECTOR
  );

  return response;
};
